export default class Accordion {
  constructor(elem) {
    // 1. set items
    const items = elem.querySelectorAll('.js-item');
    if (!items.length) { return; }

    // 1. Set event listeners
    for (let i = 0; i < items.length; i++) {
      const element = items[i];

      const trigger = element.querySelector('.js-trigger');

      if (trigger) {
        trigger.addEventListener('click', () => {
          if (element.classList.contains('is--open')) {
            element.classList.remove('is--open');
          } else {
            element.classList.add('is--open');
          }
        });
      }
    }
  }
}
